//
//
//
//


export default {

    watch: {
        isPopLogin(f) {
            if (f) {
                // 需要登录及注册统一跳转到平台用户中心
                window.UCUnified.openUCLogin();
            }
        },
    },
    computed: {
        isPopLogin: {
            get() {
                return this.$store.state.isPopLogin;
            },
            set(val) {
                this.$store.commit('updateIsPopLogin', val);
            },
        }
    },
};
